var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.userExam.finishedAt
    ? _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _vm.getBanner("exam_result_top")
            ? [
                _c("div", {
                  staticClass: "container p-4 container--fluid",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.getBanner("exam_result_top").bodyHtml
                    ),
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-layout",
                { staticClass: "exam-result-card pt-3" },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs7: "", md6: "", "text-xs-center": "" } },
                    [
                      _c(
                        "div",
                        [
                          _vm._t("result-head"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center align-center w-100",
                            },
                            [
                              _c(
                                "v-progress-circular",
                                {
                                  staticClass: "m-2",
                                  attrs: {
                                    rotate: 270,
                                    size: 130,
                                    width: 15,
                                    value: _vm.userExam.average,
                                    color: "white",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "align-center text-align-center",
                                    },
                                    [
                                      _c("div", { staticClass: "text-h3" }, [
                                        _vm._v(
                                          _vm._s(_vm.userExam.average) + " "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-top": "-10px",
                                          },
                                        },
                                        [_vm._v("%")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-sm-start white-text",
                      attrs: { xs5: "", md6: "" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "exam-status-result pe-3 ps-1",
                          class: {
                            pass: _vm.userExam.passed,
                            failure: !_vm.userExam.passed,
                          },
                        },
                        [
                          _vm.userExam.passed
                            ? _c("v-icon", { attrs: { color: "white" } }, [
                                _vm._v("done"),
                              ])
                            : _vm._e(),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.userExam.passed
                                  ? _vm.$t("exam_result.pass", {
                                      format: _vm.LETTER_FORMAT.UPTITLECASE,
                                    })
                                  : _vm.$t("exam_result.failure", {
                                      format: _vm.LETTER_FORMAT.UPTITLECASE,
                                    })
                              ) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.exam.canRetest
                        ? [
                            _c("div", { staticClass: "mt-2" }, [
                              _c("span", { staticClass: "headline" }, [
                                _vm._v(_vm._s(_vm.userExam.position)),
                              ]),
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("exam_result.place")) +
                                  "\n            "
                              ),
                              _c("span", { staticClass: "mt-1 caption" }, [
                                _vm._v(
                                  " / " +
                                    _vm._s(_vm.exam.usersCount) +
                                    " " +
                                    _vm._s(_vm.$t("exam_result.people")) +
                                    " "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt-2" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("exam_result.national_average", {
                                      format: _vm.LETTER_FORMAT.UPTITLECASE,
                                    })
                                  ) +
                                  ":\n            "
                              ),
                              _c("span", { staticClass: "caption" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.exam.averageRate) + "% "
                                ),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-3 mb-3 d-none" },
                        [
                          _c("FbShareButton", { attrs: { url: _vm.shareUrl } }),
                          _vm._v(" "),
                          _c("TwShareButton", {
                            staticClass: "mt-1",
                            attrs: { url: _vm.shareUrl, text: _vm.shareText },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.exam.isShowEvaluation,
                      expression: "exam.isShowEvaluation",
                    },
                  ],
                  staticClass: "exam-result-card p-3",
                },
                [
                  _c("SkillsChart", {
                    attrs: { skills: _vm.skills, "user-exam": _vm.userExam },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "v-tabs",
                    {
                      attrs: {
                        color: "#16B72F",
                        dark: "",
                        centered: "",
                        "fixed-tabs": "",
                        "slider-color": "yellow",
                        "icons-and-text": "",
                      },
                      model: {
                        value: _vm.active,
                        callback: function ($$v) {
                          _vm.active = $$v
                        },
                        expression: "active",
                      },
                    },
                    [
                      _vm.exam.isShowEvaluation
                        ? _c(
                            "v-tab",
                            { attrs: { ripple: "" } },
                            [
                              _vm._v("\n          評価\n          "),
                              _c("v-icon", [_vm._v("comment")]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        { attrs: { ripple: "" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("common.answer", {
                                  format: _vm.LETTER_FORMAT.UPTITLECASE,
                                })
                              ) +
                              "\n          "
                          ),
                          _c("v-icon", [_vm._v("dvr")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        { attrs: { ripple: "" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("exam_result.stats", {
                                  format: _vm.LETTER_FORMAT.UPTITLECASE,
                                })
                              ) +
                              "\n          "
                          ),
                          _c("v-icon", [_vm._v("pie_chart")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        { staticClass: "d-none", attrs: { ripple: "" } },
                        [
                          _vm._v("\n          コメント\n          "),
                          _c("v-icon", [_vm._v("comment")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.exam.useExamEvaluation &&
                      _vm.exam.examEvaluations.length > 0
                        ? _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card",
                                { attrs: { text: "" } },
                                [
                                  _c("ExamEvaluationComponent", {
                                    attrs: {
                                      examEvaluations: _vm.exam.examEvaluations,
                                      score: _vm.userExam.average,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "v-card",
                            { attrs: { text: "" } },
                            [
                              _c(
                                "v-card-title",
                                {
                                  staticClass: "ps-2 pe-2 question-report-list",
                                },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _c(
                                            "v-list",
                                            [
                                              _vm._l(
                                                _vm.groupQuestions,
                                                function (item, index) {
                                                  return [
                                                    _c(
                                                      "ExamResultQuestionGroupList",
                                                      {
                                                        key: index + "group",
                                                        attrs: {
                                                          item: item,
                                                          padding: true,
                                                          exam: _vm.exam,
                                                          "user-exam":
                                                            _vm.userExam,
                                                          examQScoreHistory:
                                                            _vm.examQScoreHistory,
                                                          questionNumber:
                                                            _vm.getQuestionNumber(
                                                              item
                                                            ),
                                                        },
                                                      }
                                                    ),
                                                    _vm._v(" "),
                                                    index + 1 <
                                                    _vm.groupQuestions.length
                                                      ? _c("v-divider", {
                                                          key:
                                                            index +
                                                            "group_divider",
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "v-card",
                            { attrs: { text: "" } },
                            _vm._l(_vm.skills, function (skill, index) {
                              return _c(
                                "div",
                                { key: index, attrs: { xs12: "" } },
                                [
                                  _c("ExamSkillReport", {
                                    attrs: {
                                      skill: skill,
                                      userExam: _vm.userExam,
                                      mobile: true,
                                    },
                                  }),
                                  _vm._v(" "),
                                  index + 1 < _vm.skills.length
                                    ? _c("v-divider", { staticClass: "m-0" })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(
                                    skill.skillItems,
                                    function (skillItem, indexItem) {
                                      return [
                                        _c("ExamSkillItemReport", {
                                          key: index + indexItem,
                                          attrs: {
                                            skillItem: skillItem,
                                            userExam: _vm.userExam,
                                            mobile: true,
                                          },
                                        }),
                                        _vm._v(" "),
                                        indexItem + 1 < skill.skillItems.length
                                          ? _c("v-divider", {
                                              key:
                                                index +
                                                indexItem +
                                                skillItem.id,
                                              staticClass: "m-0",
                                            })
                                          : _vm._e(),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { staticClass: "d-none" },
                        [
                          _c(
                            "v-card",
                            { attrs: { text: "" } },
                            [_vm._t("comment-body")],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.getBanner("exam_result_bottom")
            ? [
                _c("div", {
                  staticClass: "container p-4 container--fluid",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.getBanner("exam_result_bottom").bodyHtml
                    ),
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }